import { Attachment } from './Attachment'
import { HomeInventoryItem } from './Homes'

export interface HomeIssue {
  attachments?: Attachment[]
  createdAt?: string
  homeInventoryItem?: HomeInventoryItem
  homeInventoryItemId?: number
  homeLocation?: string
  homeLocationId: number
  id: number
  notes?: string
  resolvedAt?: string
  type?: HomeIssueType
}

export enum HomeIssueType {
  ACCESS = 'Access',
  DAMAGE = 'Damage',
  REPLACEMENT_NEEDED = 'Replacement Needed',
  WIFI = 'Wifi',
}

export interface NewHomeIssue extends HomeIssue {
  homeId: number
  homeInventoryItemId?: number
  homeLocationId: number
  type: HomeIssueType
}
